import {getGuidedActiveBoxId} from './boxChampGuidedSelectors';
import {PLAN_OP_EVENTS} from '../../scanpack/boxChampEvents';

const isFromNotFulfilled = (logData, state) => {
  const order = state.scanPackScanning.currentOrder;
  const matches = item =>
    item && item.order_item_id === logData.order_item_id && item.sku === logData.SKU;
  return [...(order?.unscanned_items || []), ...(order?.scanned_items || [])].some(
    item => matches(item) && item.from_not_fulfilled
  );
};

const stampGuidedLog = (logData, state) => {
  if (!logData || PLAN_OP_EVENTS.includes(logData.event)) return logData;
  if (isFromNotFulfilled(logData, state)) logData.not_fulfilled = true;
  const activeBoxId = getGuidedActiveBoxId(state);
  if (activeBoxId == null) return logData;
  logData.box_id = activeBoxId;
  logData.guided = true;
  return logData;
};

export default stampGuidedLog;
